module.exports = __webpack_public_path__ + "static/sakura-dd74cc84f40000c6de6cec60dfb42673.png";